import React from 'react';
import SEO from './SEO';
import ResidentBanner from './ResidentBanner';
import ResidentInfoSection from './ResidentInfoSection';
import ResidentServicesSection from './ResidentServicesSection';
import ResidentPeopleFirstSection from './ResidentPeopleFirstSection';

const ResidentPage = () => {
  return (
    <div>
      <SEO
        title="Resident – Lloyd James Media"
        description="Comprehensive resident data services for targeted marketing campaigns. Access quality residential data to reach your ideal customers effectively."
        keywords="resident data, residential data, consumer data, targeted marketing, household data, Lloyd James"
        canonical="/product"
      />
      {/* Banner Section */}
      <ResidentBanner />
      
      {/* Pink Info Section */}
      <ResidentInfoSection />
      
      {/* Services Section */}
      <ResidentServicesSection />
      
      {/* Putting People First Section (includes Simple Banner) */}
      <ResidentPeopleFirstSection />
    </div>
  );
};

export default ResidentPage;